import React, { useCallback, useMemo } from 'react';
import { RecommendToTherapyFrom, Toast, TrackerCustomEvent, useTracker } from 'common-package';
import { Icon } from '@fuxi/eevee-icon';
import service from '@/service';
import { useNav } from '@/hooks';
import { THERAPY_TYPE_2_TEXT } from '@/pages/ai-consultation/utils';

import { ALL_PAGES, MassageType2Text } from '@/constant';
import cx from './index.module.scss';

interface Props {
  goodsItem: RecommendGoodsItem;
}

const RecommendListItem: React.FC<Props> = ({ goodsItem }) => {
  const nav = useNav();
  const { sendEvent } = useTracker();

  const goodsTypes = useMemo(() => {
    const tags = goodsItem?.types
      ?.sort((a, b) => Object.keys(THERAPY_TYPE_2_TEXT)?.indexOf(a) - Object.keys(THERAPY_TYPE_2_TEXT)?.indexOf(b))
      ?.map(item => THERAPY_TYPE_2_TEXT[item])
      ?.join(' · ');
    return tags;
  }, [goodsItem?.types]);

  const handleCreateOrder = useCallback(async () => {
    try {
      const { data } = await service.service.checkStoreGoods(goodsItem?.id);
      if (!!data) {
        sendEvent?.(TrackerCustomEvent.RecommendToTherapy, {
          et: 'CLK',
          c1: RecommendToTherapyFrom.HealthRecord,
        });

        nav(ALL_PAGES.ADD_SERVICE, {
          state: {
            massageItem: goodsItem?.itemType,
            storeGoodsId: goodsItem?.id,
            bodyPart: goodsItem?.bodyPart,
            currentIsExpand: true,
          },
        });
      } else {
        Toast.fail('该方案已下架，请重新下单');
      }
    } finally {
    }
  }, [goodsItem, nav, sendEvent]);

  return (
    <div className={cx('recommend-item')} style={{ backgroundImage: `url(${goodsItem?.wxCoverImage})` }}>
      <div className={cx('color-box')} />
      <div className={cx('left')}>
        <div>
          <div className={cx('header')}>
            <div>{goodsItem?.name}</div>
            <div className={cx('line')} />
            <div>{goodsItem?.treatmentCourse}个疗程</div>
          </div>
          <div className={cx('physiotherapy-tag')}>针对 · {goodsTypes}</div>
        </div>

        <div className={cx('item-type')}>{MassageType2Text[goodsItem?.itemType]}</div>
      </div>
      <div className={cx('right')} onClick={handleCreateOrder}>
        <Icon name="arrow-right" className={cx('icon')} />
      </div>
    </div>
  );
};

export default RecommendListItem;
